var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link-site",attrs:{"href":_vm.checkLink,"target":"_blank"}},[_vm._v("\n  "+_vm._s(_vm.hostName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }